import type { ReactNode } from 'react';
import { Card } from '@/components/ui';
import { SiteHeader } from '@/components/layout/SiteHeader';

interface AuthLayoutProps {
  children: ReactNode;
}

/**
 * Shell for all auth screens (login, register, forgot password, OTP). Uses the
 * same gralmedical.ro-styled `SiteHeader` as the logged-in shell (no sidebar,
 * so no menu toggle), with the form card centered in the space below it.
 */
export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-dvh bg-canvas">
      <div className="mx-auto w-full max-w-[1440px]">
        <SiteHeader />

        <main className="flex min-h-[calc(100dvh-8rem)] flex-col items-center justify-center px-4 py-10">
          <Card className="w-full max-w-[420px] p-7 sm:p-8">{children}</Card>

          <footer className="mt-8 text-center text-xs text-ink-mute">
            © {new Date().getFullYear()} Gral Medical. Toate drepturile rezervate.
          </footer>
        </main>
      </div>
    </div>
  );
}
